import {equiprobable} from "./random";

export function spread(medians: number | number[], dispersion: number = 0.5, randomFn: () => number = Math.random) {
    let median;
    if (Array.isArray(medians)) {
        median = equiprobable(medians);
    } else {
        median = medians;
    }

    return median + median * dispersion * randomFn();
}